"use client";

import ProductCard from "./ProductCard";
import type { UnifiedProduct } from "@/lib/product-data/product.types";

export default function ProductGrid({
  products,
  basePath,
}: {
  products: UnifiedProduct[];
  basePath: string;
}) {
  return (
    <section className="py-20 px-6">
      <div className="max-w-[83.75rem] mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
        {products.map((p, i) => (
          <div key={p.id}>
            <ProductCard product={p} index={i} basePath={basePath} />
          </div>
        ))}
      </div>
    </section>
  );
}
